import { useUserStore } from '@/stores/modules/user'

const permissionDirective = {
  mounted(el, binding, vnode) {
    // value 是指定的按钮名称数组
    const { value } = binding

    const userStore = useUserStore()
    const rolePermission = userStore.rolePermission
    // console.log('directive : :::::::::-------> rolePermission:', rolePermission)
    if (!rolePermission) {
      return
    }

    // 1.1 拥有所有权限
    if (rolePermission.has_all_permissions) {
      return
    }

    // 2.1 判断是否有按钮权限
    if (value && value instanceof Array) {
      if (value.length === 0) {
        // 如果没有指定权限名称，默认有权限
        return
      }

      let hasPermission = false
      value.forEach((btnName) => {
        if (rolePermission.permissions[btnName]) {
          hasPermission = true
        }
      })

      if (!hasPermission) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    } else {
      console.log('v-permission: ', value)
      throw new Error(
        `v-permission 配置值格式错误! Like v-permission="['btn-name-1','btn-name-2']"`
      )
    }
  }
}

export const setupPermissionDirective = (app) => {
  app.directive('permission', permissionDirective)
}

export default permissionDirective
